if (!customElements.get('reca-hover-zoom')) {
  customElements.define('reca-hover-zoom', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.parent = this.parentElement;
      this.hover = matchMedia('(hover: hover) and (pointer: fine)');
      const options = { signal: this.abort.signal };
      this.parent.addEventListener('pointerenter', event => this.enter(event), options);
      this.parent.addEventListener('pointermove', event => this.move(event), options);
      this.parent.addEventListener('pointerleave', () => this.exit(), options);
      this.parent.addEventListener('click', event => {
        if (this.hasAttribute('data-active') && event.detail > 0) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, { ...options, capture: true });
      this.hover.addEventListener('change', () => this.exit(), options);
    }
    disconnectedCallback() {
      this.abort.abort();
      this.exit();
    }
    async enter(event) {
      if (!this.hover.matches || event.pointerType === 'touch') return;
      this.inside = true;
      this.lastPoint = { x: event.clientX, y: event.clientY };
      this.base = this.parent.querySelector('img');
      if (!this.base) return;
      const box = this.base.getBoundingClientRect();
      const parentBox = this.parent.getBoundingClientRect();
      const density = 1;
      this.scale = Math.min(2, Number(this.dataset.width) / (box.width * density), Number(this.dataset.height) / (box.height * density));
      if (this.scale <= 1.05) return;
      Object.assign(this.style, { left: (box.left - parentBox.left) + 'px', top: (box.top - parentBox.top) + 'px', width: box.width + 'px', height: box.height + 'px' });
      if (!this.image) {
        this.image = new Image();
        this.image.alt = '';
        this.image.src = this.dataset.source;
        this.append(this.image);
      }
      try { await this.image.decode(); } catch { return; }
      if (!this.inside || !this.isConnected || !this.hover.matches) return;
      this.image.style.width = box.width * this.scale + 'px';
      this.image.style.height = box.height * this.scale + 'px';
      this.setAttribute('data-active', '');
      this.position(this.lastPoint.x, this.lastPoint.y);
    }
    move(event) {
      this.lastPoint = { x: event.clientX, y: event.clientY };
      if (this.hasAttribute('data-active')) this.position(event.clientX, event.clientY);
    }
    position(x, y) {
      const box = this.getBoundingClientRect();
      const px = Math.max(0, Math.min(1, (x - box.left) / box.width));
      const py = Math.max(0, Math.min(1, (y - box.top) / box.height));
      this.image.style.transform = 'translate(' + (-px * box.width * (this.scale - 1)) + 'px,' + (-py * box.height * (this.scale - 1)) + 'px)';
    }
    exit() {
      this.inside = false;
      this.removeAttribute('data-active');
    }
  });
}
